export default (state, getters, rootState, rootGetters) => code => {
    let ag = state.list.filter(i => {
        return i.code === code
    })[0];
    if (!ag) return [];

    let form = rootState.finances.pay.form;
    let requests = ag.requests.filter(i => {
        if(form.ContragentType===3||form.ContragentType===4){
            return i.contragent === form.ContragentID && i.type === form.ContragentType && i.legal === form.PartnerLegalEntityId;
        }else{
            return i.contragent === form.ContragentID && i.type === form.ContragentType;
        }
    });
    let sum = Math.ceil(requests.reduce(function (sum, current) {
        return sum + current.sum;
    }, 0) * 100) / 100;
    let debt = Math.ceil(requests.reduce(function (sum, current) {
        switch (form.PaymentDirection) {
            case 0:
                return sum + (current.inp > 0 ? current.inp : 0);
            case 1:
                return sum + (current.out > 0 ? current.out : 0);
        }
    }, 0) * 100) / 100;
    let contragents = ag.contragents.filter(i => {
        return i.type === form.ContragentType;
    });
    let currency = requests[0] ? requests[0].currency : 1;
    if (!rootGetters['dictionary/currency/getIso']) return '';
    let iso = rootGetters['dictionary/currency/getIso'](currency);
    let AGCurrency = requests[0]?requests[0].AGCurrency:1;
    let AGCurrencyIso = rootGetters['dictionary/currency/getIso'](AGCurrency);
    let isNational = rootGetters['dictionary/currency/getById'](form.CurrencyId).IsNational;
    return {
        code: ag.code,
        date: ag.date,
        comment: ag.comment,
        CarryOverOfFunds: ag.CarryOverOfFunds,
        legals: ag.legals,
        course: ag.course,
        load: ag.load,
        ag,
        isNational,
        contragents,
        requests,
        currency,
        iso,
        AGCurrency,
        AGCurrencyIso,
        sum,
        debt,
    }
}
